// components/pagos/mediosPagoHelpers.js
import React from 'react';
import {
  Payment as PaymentIcon,
  AttachMoney as MoneyIcon,
  CreditCard as CreditCardIcon,
  AccountBalance as AccountBalanceIcon,
  QrCode as QrCodeIcon,
  Receipt as ReceiptIcon
} from '@mui/icons-material';

export const formatNumber = (value) => {
  if (!value && value !== 0) return '';

  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '';

  const [entero, decimal] = numValue.toFixed(2).split('.');
  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${enteroFormateado},${decimal}`;
};

export const getMedioPagoIcon = (medioPago) => {
  const nombre = medioPago?.toLowerCase() || '';
  if (nombre.includes('efectivo') || nombre.includes('contado')) {
    return <MoneyIcon fontSize="small" />;
  } else if (nombre.includes('credito') || nombre.includes('crédito')) {
    return <CreditCardIcon fontSize="small" />;
  } else if (nombre.includes('debito') || nombre.includes('débito')) {
    return <AccountBalanceIcon fontSize="small" />;
  } else if (nombre.includes('qr') || nombre.includes('mercadopago') || nombre.includes('mercado pago')) {
    return <QrCodeIcon fontSize="small" />;
  } else if (nombre.includes('cta cte') || nombre.includes('cuenta corriente')) {
    return <ReceiptIcon fontSize="small" />;
  }
  return <PaymentIcon fontSize="small" />;
};

export const getMedioPagoColor = (medioPago) => {
  const nombre = medioPago?.toLowerCase() || '';
  if (nombre.includes('efectivo') || nombre.includes('contado')) {
    return '#2e7d32';
  } else if (nombre.includes('credito') || nombre.includes('crédito')) {
    return '#1976d2';
  } else if (nombre.includes('debito') || nombre.includes('débito')) {
    return '#ed6c02';
  } else if (nombre.includes('qr') || nombre.includes('mercadopago') || nombre.includes('mercado pago')) {
    return '#009ee3';
  } else if (nombre.includes('cta cte') || nombre.includes('cuenta corriente')) {
    return '#6a1b9a';
  }
  return '#757575';
};
